import { useState, useEffect, useCallback } from "react"

export const useLottie = () => {
  const [isLoaded, setIsLoaded] = useState(false)

  const load = useCallback(() => {
    document.getElementById("web-lottie")?.setAttribute("loaded", "true")
    setIsLoaded(true)
  }, [])

  useEffect(() => {
    let script = document.getElementById("web-lottie")
    if (!script) {
      script = document.createElement("script")
      script.id = "web-lottie"
      script.setAttribute("loaded", "false")
      script.setAttribute(
        "src",
        "https://cdn.izettle.com/design-platform/lottie/5.7.3/lottie_light.min.js",
      )
      script.setAttribute("crossorigin", "anonymous")
      script.setAttribute(
        "integrity",
        "sha512-AovxT5OPANQ5TdCDH2IwdrS15iX7wph2aqm35Zoss8JV0AA1tgdGQxD65NWeeWBmQz1XHXYz8klTBS/C98RQxw==",
      )
      document.head.appendChild(script)
      script.addEventListener("load", load)
    } else if (script.getAttribute("loaded") === "false") {
      script.addEventListener("load", load)
    } else {
      setIsLoaded(true)
    }
    return () => {
      script?.removeEventListener("load", load)
    }
  }, [])

  return isLoaded
}
